import { render } from "./TestScrollButton.vue?vue&type=template&id=acb93ade&scoped=true"
import script from "./TestScrollButton.vue?vue&type=script&lang=js"
export * from "./TestScrollButton.vue?vue&type=script&lang=js"

import "./TestScrollButton.vue?vue&type=style&index=0&id=acb93ade&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb93ade"]])

export default __exports__